import React, { useState, useEffect } from "react";
import axiosService from "../../utils/axios.service";
import { Table, Badge, Container } from 'react-bootstrap';
import { format } from "date-fns"
import { PackageStatus, PackageStatusColor } from "../../enums/packageStatus.enum"
import styles from "../../styles/popupInfor.module.css"
import "./scss/customer.scss";
const Package = ({ customer }) => {
  const [packages, setPackages] = useState([])
  const [show,setShow] = useState(false)
  const getData = async () => {
    const res = await axiosService(`api/customer/get-data-package/${customer.id}`, "GET");
    const { data } = res
    if (data.code === 200) {
      const { dataPackage } = data.data
      setPackages(dataPackage.Data)
    }
  }
  useEffect(() => {
    getData()
  }, [])
  function convertCurrency(data) {
    let res = new Intl.NumberFormat('vi-VN', { style: 'currency', currency: 'VND' }).format(data)
    return res;
  };
  const hiddenPackageHistory = () =>{
    setShow(!show)
  }
  return (
    <Container className={styles.scrollTransaction}>
      <Table striped bordered hover size="sm">
        <thead>
          <tr>
            <th>Ngày cấp</th>
            <th>Tên thẻ</th>
            <th>Tình trạng</th>
            <th>Sử dụng</th>
            <th>Tiền mua</th>
            <th>Ghi chú</th>
          </tr>
        </thead>
        <tbody>
          {packages.length > 0 ?
            packages.map((x,i) => {
              return (
                <tr key={i}>
                  <td>  {format(new Date(x.created_at), 'HH:mm dd/MM/yyyy')}</td>
                  <td>{x.product_name}</td>
                  <td>
                    <Badge bg={PackageStatusColor[x.status]} text="white">
                      {PackageStatus[x.status]}
                    </Badge>
                  </td>
                  <td>{x.count_used}/{x.max_used}</td>
                  <td>{convertCurrency(x.price_of_card)}</td>
                  <td>{x.note}</td>
                </tr>
              )
            })
          :
            <tr><td>Chưa có thông tin</td></tr>
          }
        </tbody>
      </Table>
    </Container>
  )
}
export default Package